export class ProgramManualStartNotificationModel
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }

    public ControllerId: number;
    public DeviceTypeId: number;
    public IrrigationPin: number;
    public StartOrStop: number;
    public ProgramNumber: number;
    public TypeCode: number;

    private _whenForcedOn: Date;
    set WhenForcedOn(value: Date)
    {
        this._whenForcedOn = new Date(value);
    }
    get WhenForcedOn(): Date
    {
        return this._whenForcedOn;
    }
}
